import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useSelector } from "react-redux";
import { utilsState } from "../../../sotre/redux/features/utilsSlice";

const { forwardRef, useImperativeHandle } = React;

const SocialGrpoupLinkCodeSelect = forwardRef(
  ({ oldData, onChange, label }, ref) => {
    const [socialGroupLinkCode, setSocialGroupLinkCode] = useState([]);
    const [socialGroupLinkCodeOption, setSocialGroupLinkCodeOption] = useState(
      []
    );
    const [selectedSocialGroupLinkCode, setSelectedSliderTas] = useState([]);

    useImperativeHandle(ref, () => ({
      afterSubmit() {
        setSelectedSliderTas([]);
      },
    }));

    const { utils } = useSelector(utilsState);

    useEffect(() => {
      if (utils?.SOCIAL_MEDIA_LINK_CODE_VALUES?.length) {
        setSocialGroupLinkCode(utils.SOCIAL_MEDIA_LINK_CODE_VALUES);
      }
    }, [utils]);

    useEffect(() => {
      let newData = [];
      socialGroupLinkCode?.map((item) =>
        newData.push({
          value: item.value,
          label: item.name,
        })
      );
      setSocialGroupLinkCodeOption(newData);
    }, [socialGroupLinkCode]);

    function handleSocialGroupLinkCode(data) {
      setSelectedSliderTas(data);
      const newData = data.map((item) => {
        return item.value;
      });
      onChange(newData || []);
    }

    useEffect(() => {
      if (oldData?.length > 0) {
        let selectedSocialGroupLinkCode = [];
        for (let i = 0; i < oldData?.length; i++) {
          let isExist = socialGroupLinkCode.filter((item) => {
            return item.value == oldData[i];
          });
          selectedSocialGroupLinkCode.push({
            value: isExist[0]?.value,
            label: isExist[0]?.name,
          });
        }
        setSelectedSliderTas(selectedSocialGroupLinkCode);
      }
    }, [oldData, socialGroupLinkCode]);

    return (
      <div>
        {label ? (
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            {label}
          </label>
        ) : null}
        <Select
          className=""
          options={socialGroupLinkCodeOption}
          placeholder=""
          value={selectedSocialGroupLinkCode}
          onChange={handleSocialGroupLinkCode}
          isMulti
        />
      </div>
    );
  }
);

export default SocialGrpoupLinkCodeSelect;
